import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, useTranslation } from 'react-i18next';

export type ILang = 'ru' | 'ky';

const localePath = '/locales/{{lng}}/{{ns}}.json';

function i18nInit(ns: string[] = ['cm'], fallbackLng: string = 'ky', defaultNS: string = 'cm') {
  i18n
    // Подключение бэкенда i18next
    .use(Backend)
    // Автоматическое определение языка
    .use(LanguageDetector)
    // модуль инициализации
    .use(initReactI18next)
    .init({
      // resources,
      backend: {
        // for all available options read the backend's repository readme file
        loadPath: localePath,
      },
      // Стандартный язык
      fallbackLng: fallbackLng,
      debug: false,
      ns: ns,
      defaultNS: defaultNS,
      // Распознавание и кэширование языковых кук
      detection: {
        order: ['querystring', 'cookie', 'localStorage'],
        caches: ['cookie', 'localStorage'],
        lookupQuerystring: 'lang',
        lookupCookie: 'lang',
        lookupLocalStorage: 'lang',
      },
      interpolation: {
        escapeValue: false,
      },
    });
}

export { i18n, i18nInit, useTranslation };
